module.exports = __webpack_public_path__ + "img/pr-9.546c25b3.png";